import React from 'react';
import { SanarSinCulpa } from './pages/SanarSinCulpa';
export function App() {
  return <SanarSinCulpa data-id="element-0" />;
}